module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.L. Stine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, "), _c('I', [_vm._v("The Little Shop of Monsters")]), _vm._v(" and "), _c('I', [_vm._v("Mary McScary")]), _vm._v(". R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4CBmxL/tc-custom/9780545825467.jpg?1728851578646",
      "alt": "This image is the cover for the book Haunter, Goosebumps Most Wanted"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunter, Goosebumps Most Wanted\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v(" In this spinoff to the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling Goosebumps series, a tween boy is haunted by a ghost who makes him misbehave at school.")]), _c('br'), _c('br'), _vm._v("Sammy Baker is a quiet kid who wishes he wasn’t so shy and timid. He is frightened but eager to prove he can be brave. On Halloween night, he follows his friends to the Marple House, an abandoned mansion on the other side of town.Just past midnight, he feels a cold tingle at the back of his neck. The cold seeps down, a heavy chill he has never felt before. Soon, his whole head feels like a block of ice. He’s about to scream-but the cold feeling vanishes. Sammy doesn’t realize that he has just met The Haunter, and that his nightmares are only just beginning."), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0